import React from "react";
import { Col, Row } from "react-bootstrap";
import { NFTextInput } from "src/components/Shared/NewForms/NFTextInput";
import { NFDateInput } from "src/components/Shared/NewForms/NFDateInput";
import { useTranslation } from "react-i18next";

const ExpenseBanksDetailAdditional = () => {
  const { t } = useTranslation();
  return (
    <>
      <Row>
        <Col sm={6}>
          <NFTextInput title={"Created User"} fieldName={"createdUser"} disabled />
        </Col>
        <Col sm={6}>
          <NFDateInput title={"Created Date"} fieldName={"createdDate"} required />
        </Col>
      </Row>
      <Row>
        <Col sm={12}>
          <NFTextInput fieldName="comment" title={t("Comment")} />
        </Col>
      </Row>
    </>
  );
};

export default ExpenseBanksDetailAdditional;
